import { Breakpoint, type SliderConfig } from '@jsmdg/yoshi';

const mainSliderConfig: SliderConfig = {
    spaceBetween: 4,
    slidesPerView: 1.25,
    slidesPerGroup: 1,
    showPagination: false,
    showNavigation: true,
};

const thumbnailSliderConfig: SliderConfig = {
    spaceBetween: 4,
    slidesPerView: 4.3,
    slidesPerGroup: 1,
    showPagination: false,
    showNavigation: false,
    breakpoints: {
        [Breakpoint.XS]: { slidesPerView: 6.5, spaceBetween: 4 },
        [Breakpoint.SM]: { slidesPerView: 4.5, spaceBetween: 4 },
        [Breakpoint.MD]: { slidesPerView: 7.5, spaceBetween: 4 },
    },
};

export { mainSliderConfig, thumbnailSliderConfig };
